import { addMonths, addYears } from 'date-fns/esm'
import { dateUtils } from '@/utils'
import { type RecurrenceSettingsState } from '../../../../types'
import { parseDateFromCurrentState } from '../../utils/parseDateFromCurrentState'

export function computeDefaultRecurrenceEndByRecurrenceType(
  state: RecurrenceSettingsState,
  recurrenceType: uui.domain.ui.forms.ExtendedRecurrencePeriodType,
): uui.domain.YYYYMMDD {
  switch (recurrenceType) {
    case 'NO_REPEAT': {
      const currentDate = parseDateFromCurrentState(state)
      const updatedDate = addYears(currentDate, 100)

      return dateUtils.convertToYYYYMMDD(updatedDate)
    }
    // set as end the current day in the next month
    case 'DAILY': {
      const currentDate = parseDateFromCurrentState(state)
      const updatedDate = addMonths(currentDate, 1)

      return dateUtils.convertToYYYYMMDD(updatedDate)
    }

    // set as end the current day 3 months later
    case 'WEEKLY': {
      const currentDate = parseDateFromCurrentState(state)
      const updatedDate = addMonths(currentDate, 3)

      return dateUtils.convertToYYYYMMDD(updatedDate)
    }

    // set as end the current day 1 year later
    case 'MONTHLY': {
      const currentDate = parseDateFromCurrentState(state)
      const updatedDate = addYears(currentDate, 1)

      return dateUtils.convertToYYYYMMDD(updatedDate)
    }

    // set as end the current day n years later
    // where n is the period of the recurrence
    case 'ANNUALLY': {
      const {
        value: {
          recurrencePeriod: { period },
        },
      } = state
      const currentDate = parseDateFromCurrentState(state)
      const updatedDate = addYears(currentDate, period)

      return dateUtils.convertToYYYYMMDD(updatedDate)
    }
  }
}
